import React, { useEffect } from "react";
import { useSession } from "next-auth/react";
import LoginContainer from "../../container/LoginContainer";
import HomeContainer from "../../container/HomeContainer";
import { initializeEncryptionKeys } from "@/utils/cryptoKeys";
import { useTeamsAuth } from "@/context/TeamsAuthContext";

/**
 * Shared `/home` shell (auth, Teams SSO, encryption init) for `index` and `[...sessionId]`
 * routes — replaces the former optional catch-all `[[...sessionId]].tsx`.
 */
export default function HomeSessionEntry() {
  const { data: session, status } = useSession();
  const { inTeams, loading: teamsLoading, token: teamsToken } = useTeamsAuth();

  useEffect(() => {
    if (status === "authenticated") {
      const accessToken = (session as any)?.accessToken;
      void (async () => {
        await initializeEncryptionKeys(accessToken, {
          alwaysSyncPublicKey: true,
        });
      })();
    }
  }, [status, session]);

  if (inTeams) {
    if (teamsLoading) return <div className=""></div>;
    if (teamsToken) return <HomeContainer />;
  }

  if (status === "authenticated") {
    return <HomeContainer />;
  }
  if (status === "loading") {
    return <div className=""></div>;
  }
  return <LoginContainer />;
}
